import React from 'react';
import PropTypes from 'prop-types';

import appRoutes from '../../../../../../../../../../../routes/appRoutes';
import CashbackPresenter from '../../../../../../../../../../../presenters/CashbackPresenter';

const Actions = (props) => {
  const {
    fastCashId,
    cashback,
    onDeleteDialogOpen,
    onEditStateDialogOpen,
    onEditModalOpen,
  } = props;
  const canEditCashback = CashbackPresenter.isEditable(cashback);

  const handleModalOpen = () => onEditModalOpen(cashback);

  return (
    <td>
      <a
        className="action-button -in-group"
        href={appRoutes.cashbackPath(CashbackPresenter.id(cashback))}
        target="_blank"
      >
        View
      </a>
      {fastCashId && canEditCashback && (
        <button className="action-button -in-group" onClick={handleModalOpen}>
          Edit
        </button>
      )}
      {fastCashId && !CashbackPresenter.isSpent(cashback) && (
        <button
          className="action-button -in-group"
          onClick={onDeleteDialogOpen}
        >
          Delete
        </button>
      )}
      {fastCashId && CashbackPresenter.canChangeState(cashback) && (
        <button
          className="action-button -in-group"
          onClick={onEditStateDialogOpen}
        >
          Change State
        </button>
      )}
    </td>
  );
};

export default Actions;

Actions.propTypes = {
  cashback: CashbackPresenter.shape().isRequired,
  onDeleteDialogOpen: PropTypes.func.isRequired,
  onEditStateDialogOpen: PropTypes.func.isRequired,
  fastCashId: PropTypes.string,
  onEditModalOpen: PropTypes.func.isRequired,
};

Actions.defaultProps = {
  fastCashId: null,
};
